/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body.download-logs-box[_ngcontent-%COMP%] {\n  min-height: 12rem; }\n\n.download-icon[_ngcontent-%COMP%] {\n  color: #02008a; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.component.scss.shim.ngstyle.js.pre-build-optimizer.js